document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.image-scroll .scroll-images');
    if (!container) return console.error('Scroll container not found');

    const originalImages = [...container.querySelectorAll('img')];
    if (!originalImages.length) return console.error('No images found in container');

    originalImages.forEach(img => {
        const clone = img.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        container.appendChild(clone);
    });

    const scrollWidth = container.scrollWidth;
    const resetPoint = scrollWidth / 2; 
    container.scrollLeft = resetPoint;
    const autoScroll = gsap.to(container, {
        scrollLeft: `+=${resetPoint}`,
        duration: 30,     
        ease: "linear",
        repeat: -1,       
        paused: true,
        onUpdate: () => {
            if (container.scrollLeft >= scrollWidth - container.offsetWidth - 1) {
                container.scrollLeft = resetPoint;
            }
        }
    });

    container.addEventListener('mouseenter', () => autoScroll.pause());
    container.addEventListener('mouseleave', () => autoScroll.play());

    let isTouching = false;

    const handleTouchStart = () => {
        isTouching = true;
        autoScroll.pause();
    };

    const handleTouchEnd = () => {
        isTouching = false;
        autoScroll.play();
    };

    container.addEventListener('touchstart', handleTouchStart, { passive: true });
    container.addEventListener('touchend', handleTouchEnd, { passive: true });

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !isTouching) {
                    autoScroll.play();
                } else {
                    autoScroll.pause();
                }
            });
        },
        { threshold: 0.5 } 
    );

    observer.observe(container);
});
